import { AVATAR_SIZE } from './model';

export const AVATAR_SIZE_VALUES = new Map<AVATAR_SIZE, number>([
  [AVATAR_SIZE.XS, 32],
  [AVATAR_SIZE.SMALL, 40],
  [AVATAR_SIZE.MEDIUM, 48],
  [AVATAR_SIZE.LARGE, 56],
  [AVATAR_SIZE.XL, 64],
]);
